/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Upper_CaseInputs */

const en_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Upper Case`)
};

const fr_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte en majuscules`)
};

const de_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text in Großbuchstaben umwandeln`)
};

const it_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo in maiuscolo`)
};

const ru_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст в верхнем регистре`)
};

const es_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a mayúsculas`)
};

const zh_cn2_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转换为大写`)
};

const ja_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを大文字にする`)
};

const hi_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को अपर केस में बदलें`)
};

const pt_pt2_text_to_upper_case = /** @type {(inputs: Text_To_Upper_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto em maiúsculas`)
};

/**
* | output |
* | --- |
* | "Text to Upper Case" |
*
* @param {Text_To_Upper_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_upper_case = /** @type {((inputs?: Text_To_Upper_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Upper_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_to_upper_case(inputs)
	if (locale === "de") return de_text_to_upper_case(inputs)
	if (locale === "it") return it_text_to_upper_case(inputs)
	if (locale === "ru") return ru_text_to_upper_case(inputs)
	if (locale === "es") return es_text_to_upper_case(inputs)
	if (locale === "zh-CN") return zh_cn2_text_to_upper_case(inputs)
	if (locale === "ja") return ja_text_to_upper_case(inputs)
	if (locale === "hi") return hi_text_to_upper_case(inputs)
	if (locale === "pt-PT") return pt_pt2_text_to_upper_case(inputs)
	return en_text_to_upper_case(inputs)
});